function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M608 100.571L640 0v160H0l67.185-36 38.818 14.286 100.529-20 9.456 25.143 136.36-25.143 73.157 25.143L480.249 124l69.673 14.286 24.884-69.143L608 100.57z",
  fill: "#000"
});

var SvgManifestoBrokenGroundLeft = function SvgManifestoBrokenGroundLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 160,
    viewBox: "0 0 640 160",
    preserveAspectRatio: "none",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQwIiBoZWlnaHQ9IjE2MCIgdmlld0JveD0iMCAwIDY0MCAxNjAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02MDggMTAwLjU3MUw2NDAgMFYxNjBIMEw2Ny4xODUxIDEyNEwxMDYuMDAzIDEzOC4yODZMMjA2LjUzMiAxMTguMjg2TDIxNS45ODggMTQzLjQyOUwzNTIuMzQ4IDExOC4yODZMNDI1LjUwNSAxNDMuNDI5TDQ4MC4yNDkgMTI0TDU0OS45MjIgMTM4LjI4Nkw1NzQuODA2IDY5LjE0MjlMNjA4IDEwMC41NzFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgManifestoBrokenGroundLeft as ReactComponent };